/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeader200,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeader401,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeader404,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeader500,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeaderPathParams,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeaderQueryParams,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeaderQueryResponse,
} from "../../types/individualPaymentParcelsController/GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeader.ts";
import { individualPaymentHeaderViewModelSchema } from "../individualPaymentHeaderViewModelSchema.ts";

export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeaderPathParamsSchema =
  z.object({
    financialPersonId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeaderPathParams>;

export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeaderQueryParamsSchema =
  z.object({
    culture: z.string().default("pt-BR"),
  }) as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeaderQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeader200Schema =
  z.lazy(
    () => individualPaymentHeaderViewModelSchema,
  ) as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeader200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeader401Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeader401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeader404Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeader404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeader500Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeader500>;

export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeaderQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeader200Schema,
  ) as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeaderQueryResponse>;
